// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__zGjz2","balanceDisclaimer":"posDashboard_balanceDisclaimer__1gDjW"};